import React, { Suspense } from 'react';
import type { Props as ApexChartProps } from 'react-apexcharts';

// Code-splits apexcharts (~150kB gzipped) out of the main bundle. Pages render
// immediately with a skeleton while the chart chunk loads. Drop-in replacement
// for `import Chart from 'react-apexcharts'`.
const ApexChart = React.lazy(() => import('react-apexcharts'));

const LazyChart: React.FC<ApexChartProps> = (props) => (
  <Suspense
    fallback={
      <div
        className="w-full animate-pulse rounded-md bg-muted/60"
        style={{ height: typeof props.height === 'number' ? props.height : 200 }}
      />
    }
  >
    <ApexChart {...props} />
  </Suspense>
);

export default LazyChart;
